import { Component } from "react";
import { connect } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

import {
	SET_TEMPLATE_NAME_ERROR,
	SET_TEMPLATE_DESCRIPTION_ERROR,
	SET_TEMPLATE_NAME_FR,
	SET_TEMPLATE_DESCRIPTION_FR,
	SET_TEMPLATE_POST_DESCRIPTION_FR
} from "actions/types";

class Step2 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, name, description } = this.props;

		let success = true;
		if (!name) {
			dispatch({
				type: SET_TEMPLATE_NAME_ERROR
			});
			success = false;
		}

		if (!description) {
			dispatch({
				type: SET_TEMPLATE_DESCRIPTION_ERROR
			});
			success = false;
		}

		return success;
	}

	render() {
		const {
			dispatch,
			nameErrorMsg,
			descriptionErrorMsg,
			name,
			description,
			postDescription
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDInput
						label="Nom *"
						id="name-fr"
						fullWidth
						error={!!nameErrorMsg}
						helperText={nameErrorMsg}
						value={name || ""}
						onChange={e =>
							dispatch({
								type: SET_TEMPLATE_NAME_FR,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description *"
						id="descrption-fr"
						fullWidth
						multiline
						rows={5}
						error={!!descriptionErrorMsg}
						helperText={descriptionErrorMsg}
						value={description || ""}
						onChange={e =>
							dispatch({
								type: SET_TEMPLATE_DESCRIPTION_FR,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description après photo"
						id="post-descrption-fr"
						fullWidth
						multiline
						rows={3}
						value={postDescription || ""}
						onChange={e =>
							dispatch({
								type: SET_TEMPLATE_POST_DESCRIPTION_FR,
								payload: e.target.value
							})
						}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		name,
		description,
		postDescription,
		nameErrorMsg,
		descriptionErrorMsg
	} = state.templateReducer;

	return {
		name,
		description,
		postDescription,
		nameErrorMsg,
		descriptionErrorMsg
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step2
);
